// Focus (Daybook / T3 sidebar-leaning): a handful of tasks worked one at a time. Today leads with a
// single "Now" card; the sidebar manages attention with Settle/Snooze; detail opens as a centered sheet.
import "./focus.css";
import type { Concept } from "../types";
import { FocusShell } from "./Shell";
import { FocusEmptyState, FocusPageHeader } from "./chrome";
import { FocusTaskRow } from "./TaskRow";
import { FocusTaskList } from "./TaskList";
import { FocusTaskDetail } from "./TaskDetail";
import { FocusBoard } from "./Board";
import { FocusTodayScreen } from "./Today";

export const focus: Concept = {
  id: "focus",
  name: "Focus",
  className: "concept-focus",
  defaultAppearance: "system",
  detailMode: "sheet",
  rowHeight: 38,
  Shell: FocusShell,
  PageHeader: FocusPageHeader,
  EmptyState: FocusEmptyState,
  TaskRow: FocusTaskRow,
  TaskList: FocusTaskList,
  TaskDetail: FocusTaskDetail,
  Board: FocusBoard,
  TodayScreen: FocusTodayScreen,
};
